import {useState} from '#app';
import type {EducationRequest} from '~/types/infra/EducationRequest';

export const useEducationSectionState = () => useState<EducationRequest[]>('education-section-state', () => []);
